import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";
import { encodeRouteId } from "../utils/routeId";

/**
 * Parameters required to build Cloe AI breadcrumb
 */
export interface CloeAIBreadcrumbParams {
    customerTitle: string;
    appName: string;
    location: Location;
    history: any;
    lastTopicIdForChilds: number | null;
}

/**
 * Builds breadcrumb items for Cloe AI app
 */
export const buildCloeAIBreadcrumb = (
    params: CloeAIBreadcrumbParams
): IBreadcrumbItem[] => {

    const {
        customerTitle,
        appName,
        location,
        history,
        lastTopicIdForChilds
    } = params;

    const items: IBreadcrumbItem[] = [];

    // --------------------------------------------------------
    // ROOT ITEMS
    // --------------------------------------------------------

    items.push({
        text: 'ZedX Apps',
        key: "root",
        onClick: () => history.push("/")
    });

    items.push({
        text: appName,
        key: "app",
        onClick: () => history.push("/a14/welcome")
    });

    // --------------------------------------------------------
    // DETERMINE CURRENT PATH
    // (supports BrowserRouter & HashRouter)
    // --------------------------------------------------------

    let path = location.pathname || "";
    if ((!path || path === "/") && location.hash) {
        path = location.hash
            .replace(/^#/, "")
            .split("?")[0]
            .split("#")[0];
    }

    // --------------------------------------------------------
    // ROUTE-SPECIFIC BREADCRUMB ITEMS
    // --------------------------------------------------------

    // helper: chats route depends on whether we came from a topic
    const chatsRoute = lastTopicIdForChilds
        ? `/a14/chats-for-topic/${encodeRouteId(lastTopicIdForChilds)}`
        : `/a14/chats`;

    if (path === "/a14/welcome") {
        items.push({ text: "Welcome", key: "welcome", isCurrentItem: true });
    }

    // ---------------- TOPICS ----------------

    else if (path === "/a14/topics") {
        items.push({ text: "Topics", key: "topics", isCurrentItem: true });
    }

    // ---------------- CHATS ----------------

    else if (path === "/a14/chats") {
        items.push({ text: "Chats", key: "chats", isCurrentItem: true });
    }

    // ---------------- CHATS FOR TOPIC ----------------

    else if (path.startsWith("/a14/chats-for-topic")) {
        items.push({
            text: "Topics",
            key: "topics",
            onClick: () => history.push("/a14/topics")
        });
        items.push({ text: "Chats", key: "chats", isCurrentItem: true });
    }

    // ---------------- ASK CLOE (CHAT WINDOW) ----------------

    else if (path.startsWith("/a14/ask-cloe")) {
        if (lastTopicIdForChilds) {
            items.push({
                text: "Topics",
                key: "topics",
                onClick: () => history.push("/a14/topics")
            });
        }
        items.push({
            text: "Chats",
            key: "chats",
            onClick: () => history.push(chatsRoute)
        });
        items.push({ text: "Ask Cloe", key: "ask-cloe", isCurrentItem: true });
    }

    // ---------------- SETTINGS ----------------

    else if (path === "/a14/settings/item-1") {
        items.push({ text: "Settings", key: "settings", isCurrentItem: true });
        items.push({ text: "Item 1", key: "settings-item-1", isCurrentItem: true });
    }

    return items;
};